import { Column } from 'src/shared/components/Semantic/all'
import { Image } from 'src/shared/components/ui'

export const RightColumn = () => {
  return (
    <Column className="flex-1 justify-center p-4">
      <div className="relative min-h-0 flex-1 overflow-hidden rounded-[var(--radius-card-inner)] bg-muted/40">
        <Image
          src="/login/login-signup.webp?v=white"
          alt=""
          aria-hidden
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
      </div>
    </Column>
  )
}
